module.exports = __webpack_public_path__ + "static/media/Mismagius_gaussian2.fa209c89.png";